import Immutable from "immutable";
import {
  FLAG_BOARDING_GROUPS,
  GET_BOARDING_GROUPS,
  CLEAR_BOARDING_GROUPS,
  FLAG_BOARDING_GROUP_ACTIVITY,
  CLEAR_BOARDING_GROUP,
  GET_BOARDING_GROUP,
} from "../../../actions/types"
import { COLLECTION_SHAPE } from "../../../config/shapes";

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});


export default (state = INITIAL_STATE, { type, payload }) => {

  switch (type) {
    case FLAG_BOARDING_GROUPS:
      return state.setIn(["all", "loading"], payload);
    case GET_BOARDING_GROUPS:
      return state.setIn(["all", "content"], Immutable.Map(payload));
    case CLEAR_BOARDING_GROUPS:
      return state.setIn(
        ["all", "content"],
        INITIAL_STATE.getIn(["all", "content"])
      );
    case FLAG_BOARDING_GROUP_ACTIVITY:
      if (payload) {
        return state.setIn(
          ["current", "activity"],
          state.getIn(["current", "activity"]).push(payload)
        );
      }
      return state.setIn(
        ["current", "activity"],
        state.getIn(["current", "activity"]).pop()
      );
    case GET_BOARDING_GROUP:
      return state.setIn(["current", "content"], Immutable.Map(payload));
    case CLEAR_BOARDING_GROUP:
      return state.setIn(
        ["current"],
        INITIAL_STATE.getIn(["current"])
      );
    default:
      return state;
  }
}
